module.exports = __webpack_public_path__ + "static/media/red_bandana.81fba0b5.png";